const url = 'messaging';
import { api } from 'api';
import Swal from 'sweetalert2';
import { handleActions } from 'redux-actions';
import moment from "moment";

const LOADER_MESSAGING = 'LOADER_MESSAGING';
const SET_DATA_MESSAGING = 'SET_DATA_MESSAGING';
const SET_PAGE_MESSAGING = 'SET_PAGE_MESSAGING';
const SET_BUSCADOR_MESSAGING = 'SET_BUSCADOR_MESSAGING';
const SET_FILTRO_MESSAGING = 'SET_FILTRO_MESSAGING';
const SET_INICIAL_DATE_MESSAGING = 'SET_INICIAL_DATE_MESSAGING';
const SET_FINAL_DATE_MESSAGING = 'SET_FINAL_DATE_MESSAGING';
const SET_FILTER_TYPE_MESSAGING = 'SET_FILTER_TYPE_MESSAGING';

const listMessages = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_MESSAGING, cargando: true});
    const store = getStore();
    const search = store.messaging.buscador
    const filtro = store.messaging.filtro;
    const type = store.messaging.filter_type;

    const initial_date = store.messaging.initial_date;
    const final_date = store.messaging.final_date;

    let params = {page, search, initial_date, final_date, flow: type};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}/getMessages`, params).catch((error) => {
        dispatch({type: LOADER_MESSAGING, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_MESSAGING, data: data});
            dispatch({type: SET_PAGE_MESSAGING, page: page});
        }
        dispatch({type: LOADER_MESSAGING, cargando: false});
    })
};

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_MESSAGING, buscador: search});
    dispatch(listMessages(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }

    dispatch({type: SET_FILTRO_MESSAGING, filtro});
    dispatch(listMessages(1));
};

const setFinalDate = (value) => (dispatch) => {
    dispatch({type: SET_FINAL_DATE_MESSAGING, final_date: value});
    dispatch(listMessages(1));
}

const setInitialDate = (value) => (dispatch) => {
    dispatch({type: SET_INICIAL_DATE_MESSAGING, initial_date: value});
    dispatch(listMessages(1));
}

const filterType = (filtro) => (dispatch) => {
    dispatch({type: SET_FILTER_TYPE_MESSAGING, filter_type: filtro});
    dispatch(listMessages(1));
}

export const actions = {
    listMessages,
    search,
    filtro,
    setFinalDate,
    setInitialDate,
    filterType
};

export const reducer = {
    [LOADER_MESSAGING]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_MESSAGING]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_MESSAGING]: (state, { page }) => {
        return {...state, page }
    },
    [SET_BUSCADOR_MESSAGING]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_MESSAGING]: (state, { filtro }) => {
        return {...state, filtro }
    },
    [SET_INICIAL_DATE_MESSAGING]: (state, { initial_date }) => {
        return{
            ...state,
            initial_date
        }
    },
    [SET_FINAL_DATE_MESSAGING]: (state, { final_date }) => {
        return{
            ...state,
            final_date
        }
    },    
    [SET_FILTER_TYPE_MESSAGING]: (state, { filter_type }) => {
        return{
            ...state,
            filter_type
        }
    },    
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },

    buscador: '',
    filtro: null,
    initial_date: moment().date(1).format("DD/MM/YYYY"),
    final_date: moment().format("DD/MM/YYYY"),
    filter_type_list: [
      {value: -1, label: 'Todos'},
      {value: 0, label: 'Enviados'},
      {value: 1, label: 'Recibidos'}
    ],
    filter_type: -1,    
};

export default handleActions(reducer, initialState)
